import { createFileRoute, notFound } from '@tanstack/react-router';
import { useEffect } from 'react';

import { AppIntlProvider } from '@/lib/i18n/intl-provider';
import { PublicChatView } from '@/components/public-chat/public-chat-view';
import { loadPublicChat } from '@/lib/public-chat/load-public-chat';

export const Route = createFileRoute('/public/chat/$slug')({
  loader: async ({ params, location }) => {
    const data = await loadPublicChat(params.slug, location.searchStr);
    if (!data) throw notFound();
    return data;
  },
  component: PublicChatRoute,
});

function PublicChatRoute() {
  const { slug } = Route.useParams();
  const { info, locale, messages, token } = Route.useLoaderData();

  useEffect(() => {
    document.title = info.kbName;
  }, [info.kbName]);

  return (
    <AppIntlProvider locale={locale} messages={messages}>
      <PublicChatView
        tenantName={info.tenantName}
        kbName={info.kbName}
        slug={slug}
        authMode={info.authMode as 'none' | 'pin' | 'token' | 'ip'}
        initialToken={token}
        conversationStarters={info.conversationStarters}
        ipAllowed={info.ipAllowed}
      />
    </AppIntlProvider>
  );
}
